import * as React from 'react'
import classNames from 'classnames'

/**
 * Zamiennik `TabContent`/`TabPane` z reactstrap 6.
 *
 * Reactstrap podawał `activeTabId` przez legacy context (`getChildContext`), usunięty
 * w React 19. Nieaktywne panele nadal się renderują, tylko są schowane - tak jak było.
 *
 * Chowanie robi teraz sam komponent (`hidden`), a nie bootstrapowe
 * `.tab-content > .tab-pane { display: none }`. Nazwy klas zostają, bo celuje w nie
 * `assets/styles/admin-panel.scss` (`.tab-content .tab-pane .tab-pane-inner`).
 */

const TabContext = React.createContext<unknown>(undefined)

type TabContentProps = React.HTMLAttributes<HTMLDivElement> & {
  activeTab?: unknown
  children?: React.ReactNode
}

export const TabContent: React.FC<TabContentProps> = ({
  activeTab,
  className,
  children,
  ...rest
}) => (
  <TabContext.Provider value={activeTab}>
    <div className={classNames('tab-content', className)} {...rest}>
      {children}
    </div>
  </TabContext.Provider>
)

type TabPaneProps = React.HTMLAttributes<HTMLDivElement> & {
  tabId?: unknown
  children?: React.ReactNode
}

export const TabPane: React.FC<TabPaneProps> = ({
  tabId,
  className,
  children,
  ...rest
}) => {
  const activeTab = React.useContext(TabContext)

  const isActive = tabId === activeTab

  return (
    <div
      className={classNames('tab-pane', className, { active: isActive })}
      hidden={!isActive}
      {...rest}
    >
      {children}
    </div>
  )
}
